import React, {Component} from 'react';
import {Grid, Row, Col, Checkbox} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import KierowcyTable from "./components/KierowcyTable";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KierowcyForm from "./components/KierowcyForm";
import KierowcyService from "./KierowcyService";
import ReactNotify from 'react-notify';
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class KierowcyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kierowcy: [],
            kierowcyNoFilters:[],
            kierowca: null,
            pokazFormularz: false,
            wlaczSzukanie: true,
            czyPokazacKierowcowZNumeremEBus: false,
        };
        this.pobierzKierowcow = this.pobierzKierowcow.bind(this);
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
        this.onClickUsun = this.onClickUsun.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onClickCheckbox = this.onClickCheckbox.bind(this);
    }

    componentDidMount() {
        this.pobierzKierowcow()
    }

    pobierzKierowcow() {
        KierowcyService.getKierowcy().then(function (response) {
            this.setState({kierowcy: response.data, kierowcyNoFilters:Array.from(response.data)})
        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, kierowca: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({kierowca: obj})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc kierowcę: ' + obj.imie + ' ' + obj.nazwisko)) {
            KierowcyService.deleteKierowca(obj.idKi).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto kierowcę', "", 3000)
                    this.pobierzKierowcow();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania kierowcy', "", 3000)
                }
            }.bind(this))

        }
    }

    onClickZapisz(obj, czyEdycja) {

        if (czyEdycja) {
            KierowcyService.editKierowca(this.state.kierowca.idKi, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano kierowcę', "", 3000)
                    this.pobierzKierowcow();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji kierowcy', "", 3000)
                }
            }.bind(this))
        }
        else {
            KierowcyService.addKierowca(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano kierowcę', "", 3000)
                    this.pobierzKierowcow();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania kierowcy', "", 3000)
                }
            }.bind(this))
        }

        this.zamknijFormularz();

    }

    onClickCheckbox(){
        if(this.state.czyPokazacKierowcowZNumeremEBus){
            // tak => zmiana na nie
            this.setState({kierowcy:Array.from(this.state.kierowcyNoFilters),
                czyPokazacKierowcowZNumeremEBus:!this.state.czyPokazacKierowcowZNumeremEBus
            })
        }else{

            let arr = this.state.kierowcy.sort((a,b)=>{
                if((Boolean(a.nrTelEbus) && !Boolean(b.nrTelEbus))||(Boolean(a.fcmToken) && !Boolean(b.fcmToken))) return -1
                else return 1
            })

            this.setState({
                kierowcy:arr,
                czyPokazacKierowcowZNumeremEBus:!this.state.czyPokazacKierowcowZNumeremEBus
            })
        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'DashboardContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-zasobami',
                                    text: 'Zarządzanie zasobami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-zasobami/kierowcy', text: 'Kierowcy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazFormularz)}>
                                <KonfiguracjaHeader pokazFormularz={this.pokazFormularz}
                                                    tekstDodaj={'Dodaj kierowcę'}
                                                    pokazButtonSzukaj={false}
                                />
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                                <KierowcyForm handleClickZapisz={this.onClickZapisz}
                                              handleClickAnuluj={this.zamknijFormularz}
                                              kierowca={this.state.kierowca}
                                />
                            </TopIf>
                            <div>
                                <Checkbox onClick={this.onClickCheckbox} checked={this.state.czyPokazacKierowcowZNumeremEBus}>Kliknij, aby pokazać najpierw kierowców którzy odbywają kurs i posiadają telefon służbowy eBus</Checkbox>
                            </div>
                            <TopIf isTrue={Boolean(this.state.kierowcy)}>
                                <KierowcyTable data={this.state.kierowcy}
                                               wlaczSzukanie={this.state.wlaczSzukanie}
                                               handleEdytuj={this.onClickEdytuj}
                                               handleUsun={this.onClickUsun}/>
                            </TopIf>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/kierowcy/KierowcyContainer.js